// src/ScriptContext.js
import { createContext } from 'react';

/**
 * Context provides both the shared project registry
 * and the currently selected activeFilter.
 */
const ScriptContext = createContext({
  projects: [],
  activeFilter: 'category-all'
});

export default ScriptContext;
